import { AnalyticsReportTable } from '../../widgets/analytics/analyticsReportTable';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';

// Страница отображения таблицы сводного отчета
export function AnalyticsReportPage() {

    return (
        <div className="analytics-page-div">
            <ContentHeader title="Сводный отчёт" />
            <div className="analytics-table-wrap">
                <AnalyticsReportTable />
            </div>
        </div>
    );
}

